import { toast, AddIcon, Button, Chip, FormControl, Input, Tooltip, ButtonGroup, SaveIcon, Spinner } from '@atlas-design-system/react';
import { React, useState } from 'react';
import { useFetchWrapper } from './useFetchWrapper';
import { useStateWithCallback } from './useStateWithCallback';

export default function PccListInput(props) {
    const [lastSavedPccList, setLastSavedPccList] = useStateWithCallback(props.tags ?? []);
    const [tags, setTags] = useStateWithCallback(props.tags ?? []);
    const [inputValue, setInputValue] = useState('');
    const [loading, setLoading] = useState(false);
    const [canSave, setCanSave] = useState(false,);

    var myFetch = useFetchWrapper(props.authKey);

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && inputValue && inputValue.length >= 3 && inputValue.length <= 4) {
            if (!tags.includes(inputValue)) {
                setTags([...tags, inputValue], (_, newValue) => calcCanSave(newValue));
            } else
                toast.warning(`PCC ${inputValue} already exists`, { autoClose: 5000, position: 'top-right' });
            setInputValue('');
        } else if (e.key === 'Backspace' && !inputValue && tags.length) {
            setTags(tags.slice(0, tags.length - 1), (_, newValue) => calcCanSave(newValue));
        }
    };

    const calcCanSave = (newTags, lastValue) => {
        const a = newTags;
        const b = lastValue ?? lastSavedPccList;
        if (a.every(r => b.includes(r)) && b.every(r => a.includes(r))) {
            setCanSave(false);
        } else {
            setCanSave(true);
        }
    }

    const handleChange = (e) => {
        setInputValue(e.target.value.toUpperCase());
    };

    const savePccList = () => {
        setLoading(true);
        myFetch.post("api/UploadPccList", [...tags])
            .then(a => {
                if (a) {
                    toast.success(`PCC list saved`, { autoClose: 5000, position: 'top-right' });
                    setLastSavedPccList([...tags], (_, newValue) => calcCanSave([...tags], [...newValue]));
                }
                return console.log('Save PCC list response is: ' + a);
            }).finally(() => setLoading(false));
    }

    return (
        <div style={{ display: 'inline-flex', marginTop: 10 }}>
            {tags.map((tag, index) => (
                <Chip key={index} style={{ marginTop: 9, marginRight: 5 }}
                    hasError={!tag || tag.length < 3 || tag.length > 4}
                    onClose={() => {
                        var newTags = [...tags];
                        newTags.splice(index, 1)
                        setTags(newTags, (_, newValue) => calcCanSave(newValue));
                    }}
                    value={tag}
                />
            ))}
            <ButtonGroup >
                <FormControl hideLabel={true} label='' className='no-label'
                    error={inputValue.length !== 0 && (inputValue.length < 3 || inputValue.length > 4) ? "Invalid PCC" : ""}>
                    <Input maxLength={4}
                        style={{ textTransform: 'uppercase', width: 100, marginBottom: 3 }}
                        type="text"
                        placeholder="new PCC"
                        value={inputValue}
                        onChange={handleChange}
                        onKeyDown={handleKeyDown}
                    />
                </FormControl>
                <Tooltip content="Add PCC">
                    <Button icon={<AddIcon />}
                        appearance='tertiary'
                        style={{ marginLeft: 5, marginRight: 5 }}
                        onClick={() => handleKeyDown({ key: 'Enter' })}
                        disabled={!(inputValue.length >= 3 && inputValue.length <= 4)} />
                </Tooltip>
                <Tooltip content="Save current PCC list">
                    <Button icon={<SaveIcon />}
                        onClick={savePccList}
                        disabled={!canSave}
                        appearance='tertiary' />
                </Tooltip>
            </ButtonGroup>
            {loading && <Spinner overlay percent={50} primaryLabel="Please wait..." secondaryLabel="Saving PCC list in our storage..." />}
        </div>
    );
}